import {mapActions} from "vuex"

export default {
  methods: {
    ...mapActions("survey", [
      "setCurrentStep",
      "setSurveyComplete",
      "setBodyPart",
      "setNeedsAppointment",
      "clearAnswers",
    ]),

    goToStartIfNecessary() {
      if (!this.$store.state.survey.answers.bodyPart) {
        if (!this.$route.name || this.$route.name !== this.routes.step1.name) {
          this.$router.push(this.routes.step1);
        }
      }
    },

    goToStartIfSurveyNotComplete() {
      if (this.$store.state.survey.surveyComplete === null) {
        if (!this.$route.name || this.$route.name !== this.routes.step1.name) {
          this.$router.push(this.routes.step1);
        }
      }
    },

    getSectionQuestions(section) {
      return this.$store.getters["survey/getSectionQuestions"](section);
    },

    sectionQuestionsAnswered(section, questions) {
      for (let i in questions) {
        if (questions.hasOwnProperty(i)) {
          const hasBeenAnswered = this.$store.state.survey.answers[`section${section}`][i] !== null;
          const hasBeenSkipped = questions[i].skipQuestion && questions[i].skipQuestion(this.$store.state.survey);

          if (!hasBeenAnswered && !hasBeenSkipped) {
            return false;
          }
        }
      }

      return true;
    },

    questionKeyToInt(questionKey) {
      return parseInt(questionKey.replace(/^\D+/g, ""));
    },
  },
};
